import React from 'react';
import styled from 'styled-components';
import { CheckOutlined } from '@ant-design/icons';
import { COLOR, FONT_SIZE, RADIUS, SPACING } from '../../../constants/theme';

const Nav = styled.nav`
  display: flex;
  gap: 6px;
  margin: ${SPACING.lg} 0 6px;
`;

const Step = styled.div`
  flex: 1;
  text-align: center;
  font-size: ${FONT_SIZE.stepLabel};
  font-weight: ${({ isCurrent, isComplete }) =>
    isCurrent || isComplete ? 700 : 500};
  line-height: 1.3;
  color: ${({ isCurrent, isDone, isComplete }) => {
    if (isCurrent || isComplete) return COLOR.primary;
    if (isDone) return COLOR.textSecondary;
    return COLOR.textMuted;
  }};
`;

const Bar = styled.span`
  display: block;
  height: 4px;
  margin-bottom: 6px;
  border-radius: ${RADIUS.sm};
  background: ${({ isCurrent, isDone, isComplete }) => {
    if (isCurrent || isComplete) return COLOR.primary;
    if (isDone) return COLOR.primaryBorderStrong;
    return COLOR.border;
  }};
`;

const Counter = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  font-size: ${FONT_SIZE.stepLabel};
  font-weight: ${({ isComplete }) => (isComplete ? 600 : 400)};
  letter-spacing: 0.06em;
  color: ${({ isComplete }) => (isComplete ? COLOR.success : COLOR.textMuted)};
`;

const StepBar = ({
  steps = [],
  currentStepNumber,
  counterPrefix,
  counterLabel,
}) => {
  if (!steps.length) return null;

  // Past the last step (e.g. payment received) every step shows as finished
  // in full colour, rather than all pale with none current.
  const isComplete = currentStepNumber > steps.length;

  return (
    <>
      <Nav aria-label="Progress">
        {steps.map(({ key, title }, index) => {
          const stepNumber = index + 1;

          return (
            <Step
              key={key}
              isCurrent={stepNumber === currentStepNumber}
              isDone={stepNumber < currentStepNumber}
              isComplete={isComplete}
              aria-current={
                stepNumber === currentStepNumber ? 'step' : undefined
              }
            >
              <Bar
                isCurrent={stepNumber === currentStepNumber}
                isDone={stepNumber < currentStepNumber}
                isComplete={isComplete}
              />
              {title}
            </Step>
          );
        })}
      </Nav>
      <Counter isComplete={isComplete}>
        {isComplete && <CheckOutlined aria-hidden />}
        {counterPrefix ? `${counterPrefix} · ` : ''}
        {counterLabel || `${currentStepNumber} of ${steps.length}`}
      </Counter>
    </>
  );
};

export default StepBar;
